module.exports = __webpack_public_path__ + "static/media/php.7634d1a3.svg";